import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { PopoverVariantType } from '../../popover/variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => ({
    inputVariant: "REGULAR" /* InputDateInternalVariantType.REGULAR */,
    popoverVariant: {
        [DeviceBreakpointsType.DESKTOP]: PopoverVariantType.INPUT_DATE,
        [DeviceBreakpointsType.TABLET]: PopoverVariantType.INPUT_DATE,
        [DeviceBreakpointsType.MOBILE]: PopoverVariantType.INPUT_DATE,
    },
    popoverCloseButton: {
        display: 'flex',
        justify_content: 'flex-end',
    },
    popoverCalendarContainer: {
        padding_top: FOUNDATIONS.spacing_200,
        padding_left: FOUNDATIONS.spacing_250,
        padding_right: FOUNDATIONS.spacing_250,
    },
});
//# sourceMappingURL=regular.js.map